import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TriggerModeOption } from "../trigger-mode-radio-group/trigger-mode-radio-group.component";

@Component({
  selector: "app-flow-test-device-section",
  templateUrl: "./flow-test-device-section.component.html",
  styleUrls: [
    "../app-install/app-install-trigger-form.component.scss",
    "./shared-trigger-section.component.scss",
  ],
})
export class FlowTestDeviceSectionComponent implements OnInit {
  @Input() group!: FormGroup;
  @Input() modeOptions: TriggerModeOption[] = [];
  @Input() requirementLabel = "Required";
  @Input() generateHint =
    "A realistic sandbox device will be generated with random hardware and OS details.";
  @Input() specifyHint =
    "These values are saved to the sandbox hardware device and exposed to flow conditions as Device context.";

  ngOnInit(): void {
    if (this.group) {
      this.syncMakeControl(this.group.get("system_name")!.value);
    }
  }

  get mode(): string {
    return this.group.get("mode")!.value;
  }

  get systemName(): "iOS" | "Android" {
    return this.group.get("system_name")!.value;
  }

  onSystemNameChange(systemName: "iOS" | "Android"): void {
    if (systemName === "iOS") {
      this.group.patchValue({ make: "Apple", model: "iPhone" });
    } else {
      this.group.patchValue({ make: "Samsung", model: "" });
    }
    this.syncMakeControl(systemName);
  }

  private syncMakeControl(systemName: "iOS" | "Android"): void {
    const makeControl = this.group.get("make")!;
    if (systemName === "iOS") {
      makeControl.disable({ emitEvent: false });
    } else {
      makeControl.enable({ emitEvent: false });
    }
  }
}
